import React from 'react';
const dialogsContextState = {
  openDialog: () => null,
  closeDialog: () => null
};
export const DialogsContext = /*#__PURE__*/React.createContext(dialogsContextState);